import 'magnific-popup/dist/jquery.magnific-popup.min.js';
export default {
  init() {
    $('#video_gallery').slick({
      centerMode: true,
      centerPadding: '60px',
      slidesToShow: 3,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            arrows: true,
            centerMode: false,
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 580,
          settings: {
            arrows: false,
            slidesToShow: 1,
          },
        },
      ],
    });
    $('#video_gallery a').magnificPopup({
      type:'iframe',
    });
  },
  finalize() { 

  },
};
  


// WEBPACK FOOTER //
// ./scripts/routes/home.js